// assets/ib-quiz.js
// Inner Botanica – Sanctuary Quiz Logic & Rendering

(function() {
  var DATA = window.IB_QUIZ_DATA || {};
  var questions = DATA.questions || [];
  var whispers = DATA.whispers || {};
  var archetypes = DATA.archetypes || {};
  var overlays = DATA.secondaryOverlays || {};
  var productLinks = DATA.productLinks || {};
  var productCtas = DATA.productCtas || {};
  var supportProducts = DATA.supportProducts || {};
  var productTestimonials = DATA.productTestimonials || {};
  var heroImages = DATA.heroImages || {};
  var productThumbs = DATA.productThumbs || {};



  var weightedQuestionIds = ["q1", "q10", "q15"];

  var archetypePriority = ["VEA", "SE", "QS", "HK", "BSO", "US"];

  var currentIndex = 0;
  var answers = [];
  var scores = resetScores();

  var sectionEl = document.getElementById("ib-quiz");
  if (!sectionEl) {
    console.warn("[IB Quiz] #ib-quiz not found on page");
    return;
  }

  var stateIntro = sectionEl.querySelector(".ib-quiz__state--intro");
  var stateQuestions = sectionEl.querySelector(".ib-quiz__state--questions");
  var stateLoading = sectionEl.querySelector(".ib-quiz__state--loading");
  var stateResults = sectionEl.querySelector(".ib-quiz__state--results");

  var progressLabelCurrent = sectionEl.querySelector("#ib-quiz-current");
  var progressLabelTotal = sectionEl.querySelector("#ib-quiz-total");
  var progressFill = sectionEl.querySelector(".ib-quiz-progress__fill");

  var questionTextEl = sectionEl.querySelector("#ib-quiz-question-text");
  var answersContainer = sectionEl.querySelector("#ib-quiz-answers");
  var eyebrowEl = sectionEl.querySelector("#ib-quiz-eyebrow");
  var whisperEl = sectionEl.querySelector("#ib-quiz-whisper");

  var btnStart = sectionEl.querySelector('[data-quiz-action="start"]');
  var btnNext = sectionEl.querySelector('[data-quiz-action="next"]');
  var btnBack = sectionEl.querySelector('[data-quiz-action="back"]');

  var resultsContainer = sectionEl.querySelector("#ib-quiz-results");
  // Stores the most recent completed result so we can email it
  var lastResult = {
    primaryKey: null,
    primaryName: null,
    secondaryKey: null,
    secondaryName: null,
    html: ""
  };

  function resetScores() {
    return {
      HK: 0,
      QS: 0,
      SE: 0,
      US: 0,
      BSO: 0,
      VEA: 0
    };
  }

  if (btnStart) {
    btnStart.addEventListener("click", function() {
      switchState("questions");
      initQuiz();
    });
  }

  if (btnNext) {
    btnNext.addEventListener("click", handleNext);
  }

  if (btnBack) {
    btnBack.addEventListener("click", handleBack);
  }

  // Handle #ib-quiz-start anchor link from marketing sections
  function checkHashAndStart() {
    if (window.location.hash === "#ib-quiz-start") {
      // Hide marketing sections (everything before the quiz section)
      hideMarketingSections();
      switchState("questions");
      initQuiz();
      // Scroll to top of page
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  }

  // Hide marketing custom sections when quiz starts (with zoom & fade transition)
  function hideMarketingSections() {
    var quizSec1 = document.querySelector(".quiz-sec1");
    var quizSec2 = document.querySelector(".quiz-sec2");
    var sectionsToTransition = [];

    // Collect Shopify section wrappers
    var quizSection = document.querySelector(".section-ib-quiz");
    if (quizSection) {
      var sibling = quizSection.previousElementSibling;
      while (sibling) {
        if (sibling.id && sibling.id.startsWith("shopify-section-")) {
          sectionsToTransition.push(sibling);
        }
        sibling = sibling.previousElementSibling;
      }
    }

    // Add class to body to trigger quiz fade-in
    document.body.classList.add("ib-quiz-active");

    // Start the zoom & fade out transition
    if (quizSec1) quizSec1.classList.add("ib-quiz-transitioning");
    if (quizSec2) quizSec2.classList.add("ib-quiz-transitioning");
    sectionsToTransition.forEach(function(el) {
      el.classList.add("ib-quiz-transitioning");
    });

    // After transition completes, hide elements completely
    setTimeout(function() {
      if (quizSec1) {
        quizSec1.classList.remove("ib-quiz-transitioning");
        quizSec1.classList.add("ib-quiz-hidden");
      }
      if (quizSec2) {
        quizSec2.classList.remove("ib-quiz-transitioning");
        quizSec2.classList.add("ib-quiz-hidden");
      }
      sectionsToTransition.forEach(function(el) {
        el.classList.remove("ib-quiz-transitioning");
        el.classList.add("ib-quiz-hidden");
      });
    }, 750); // Slightly longer than CSS transition (700ms)
  }

  // Show marketing sections (for when user might want to go back)
  function showMarketingSections() {
    var quizSec1 = document.querySelector(".quiz-sec1");
    var quizSec2 = document.querySelector(".quiz-sec2");

    // Remove hidden class to make visible again
    if (quizSec1) quizSec1.classList.remove("ib-quiz-hidden");
    if (quizSec2) quizSec2.classList.remove("ib-quiz-hidden");

    var quizSection = document.querySelector(".section-ib-quiz");
    if (quizSection) {
      var sibling = quizSection.previousElementSibling;
      while (sibling) {
        if (sibling.id && sibling.id.startsWith("shopify-section-")) {
          sibling.classList.remove("ib-quiz-hidden");
        }
        sibling = sibling.previousElementSibling;
      }
    }

    document.body.classList.remove("ib-quiz-active");
  }

  // Check on page load
  checkHashAndStart();

  // Also listen for hash changes (in case user clicks button after page load)
  window.addEventListener("hashchange", checkHashAndStart);

  function switchState(state) {
    [stateIntro, stateQuestions, stateLoading, stateResults].forEach(function(el) {
      if (!el) return;
      el.classList.remove("is-active");
    });

    if (state === "intro" && stateIntro) stateIntro.classList.add("is-active");
    if (state === "questions" && stateQuestions) stateQuestions.classList.add("is-active");
    if (state === "loading" && stateLoading) {
      resetLoadingSteps();
      stateLoading.classList.add("is-active");
    }
    if (state === "results" && stateResults) stateResults.classList.add("is-active");
  }

  function resetLoadingSteps() {
    var steps = document.querySelectorAll(".ib-quiz-loading__step");
    steps.forEach(function(step) {
      step.classList.remove("active", "complete");
    });
  }

  function initQuiz() {
    currentIndex = 0;
    answers = [];
    scores = resetScores();

    if (progressLabelTotal) {
      progressLabelTotal.textContent = String(questions.length);
    }

    renderQuestion();
  }

  function renderQuestion() {
    var q = questions[currentIndex];
    if (!q) return;

    if (btnNext) {
      btnNext.disabled = true;
    }

    if (progressLabelCurrent) {
      progressLabelCurrent.textContent = String(currentIndex + 1);
    }

    if (progressFill) {
      var pct = ((currentIndex + 1) / questions.length) * 100;
      progressFill.style.width = pct + "%";
    }

    if (questionTextEl) questionTextEl.textContent = q.text || "";
    if (eyebrowEl) eyebrowEl.textContent = q.eyebrow || "";
    if (whisperEl) whisperEl.textContent = whispers[q.id] || "";

    if (answersContainer) {
      answersContainer.innerHTML = "";

      // Add animating class to trigger staggered entrance animation
      answersContainer.classList.add("ib-animating");

      q.choices.forEach(function(choice) {
        var btn = document.createElement("button");
        btn.className = "ib-quiz-answer";
        btn.type = "button";
        btn.textContent = choice.text;
        btn.setAttribute("data-choice", choice.value);
        btn.setAttribute("data-archetype", choice.archetype);
        btn.addEventListener("click", function() {
          handleAnswerClick(q.id, choice, btn);
        });
        answersContainer.appendChild(btn);
      });

      var existing = answers.find(function(a) {
        return a.questionId === q.id;
      });

      if (existing) {
        var btn = answersContainer.querySelector('[data-choice="' + existing.choiceValue + '"]');
        if (btn) {
          btn.classList.add("is-selected");
          if (btnNext) btnNext.disabled = false;
        }
      }

      // Remove animating class after animations complete (350ms + 200ms max delay + buffer)
      setTimeout(function() {
        answersContainer.classList.remove("ib-animating");
      }, 600);
    }

    if (btnBack) {
      if (currentIndex === 0) {
        btnBack.disabled = true;
        btnBack.classList.add("is-disabled");
      } else {
        btnBack.disabled = false;
        btnBack.classList.remove("is-disabled");
      }
    }
  }

  function handleAnswerClick(questionId, choice, btn) {
    if (!answersContainer) return;

    // Prevent double-clicks during transition
    if (answersContainer.dataset.transitioning === "true") return;

    Array.prototype.forEach.call(answersContainer.children, function(child) {
      child.classList.remove("is-selected");
    });
    btn.classList.add("is-selected");

    var existingIndex = answers.findIndex(function(a) {
      return a.questionId === questionId;
    });

    var answerObj = {
      questionId: questionId,
      choiceValue: choice.value,
      archetype: choice.archetype
    };

    if (existingIndex > -1) {
      answers[existingIndex] = answerObj;
    } else {
      answers.push(answerObj);
    }

    // Auto-advance after selection animation completes
    answersContainer.dataset.transitioning = "true";
    setTimeout(function() {
      answersContainer.dataset.transitioning = "false";
      if (currentIndex < questions.length - 1) {
        currentIndex += 1;
        renderQuestion();
      } else {
        finishQuiz();
      }
    }, 450); // Wait for selection animation (400ms) + small buffer
  }

  function handleNext() {
    if (currentIndex < questions.length - 1) {
      currentIndex += 1;
      renderQuestion();
    } else {
      finishQuiz();
    }
  }

  function handleBack() {
    if (currentIndex > 0) {
      currentIndex -= 1;
      renderQuestion();
    }
  }

  function finishQuiz() {
    // Scroll to top so user sees the loading animation
    window.scrollTo({ top: 0, behavior: "smooth" });

    switchState("loading");
    animateLoadingSteps();

    setTimeout(function() {
      calculateScores();
      var result = determineArchetypes();
      renderResults(result.primary, result.secondary);
      sendQuizEvent(result.primary, result.secondary);
      switchState("results");
    }, 3200);
  }

  function animateLoadingSteps() {
    var steps = document.querySelectorAll(".ib-quiz-loading__step");
    var stepDelay = 900; // Time each step is active before moving to next

    steps.forEach(function(step, index) {
      // Show step
      setTimeout(function() {
        step.classList.add("active");
        // Mark previous step as complete
        if (index > 0) {
          steps[index - 1].classList.remove("active");
          steps[index - 1].classList.add("complete");
        }
      }, index * stepDelay);

      // Mark final step complete before results
      if (index === steps.length - 1) {
        setTimeout(function() {
          step.classList.remove("active");
          step.classList.add("complete");
        }, (index + 1) * stepDelay);
      }
    });
  }

  function calculateScores() {
    scores = resetScores();

    answers.forEach(function(ans) {
      if (!scores.hasOwnProperty(ans.archetype)) return;

      scores[ans.archetype] += 1;

      if (weightedQuestionIds.indexOf(ans.questionId) !== -1) {
        scores[ans.archetype] += 2;
      }
    });

    console.log("[IB Quiz] Scores:", scores);
  }

  function determineArchetypes() {
    var entries = Object.keys(scores).map(function(key) {
      return [key, scores[key]];
    });

    var maxScore = -Infinity;
    entries.forEach(function(pair) {
      if (pair[1] > maxScore) maxScore = pair[1];
    });

    var topKeys = entries
      .filter(function(pair) {
        return pair[1] === maxScore;
      })
      .map(function(pair) {
        return pair[0];
      });

    var primary;
    if (topKeys.length === 1) {
      primary = topKeys[0];
    } else {
      primary = breakTieWithPriority(topKeys);
    }

    var secondary = null;
    var secondScore = -Infinity;
    entries.forEach(function(pair) {
      var key = pair[0];
      var val = pair[1];
      if (key === primary) return;
      if (val > secondScore) {
        secondScore = val;
        secondary = key;
      }
    });

    return { primary: primary, secondary: secondary };
  }

  function breakTieWithPriority(tiedKeys) {
    var chosen = tiedKeys[0];
    var bestIdx = Infinity;

    tiedKeys.forEach(function(key) {
      var idx = archetypePriority.indexOf(key);
      if (idx !== -1 && idx < bestIdx) {
        bestIdx = idx;
        chosen = key;
      }
    });

    return chosen;
  }

  function convertPseudoBullets(text) {
    if (!text) return "";

    var trimmed = text.trim();
    if (!trimmed) return "";

    var lines = trimmed.split("\n");
    var html = [];
    var inList = false;

    function closeList() {
      if (inList) {
        html.push("</ul>");
        inList = false;
      }
    }

    lines.forEach(function(rawLine) {
      var line = rawLine.trim();

      // Blank line = close any open list, no <p> needed
      if (!line) {
        closeList();
        return;
      }

      // Line starting with "•" = bullet
      if (line.indexOf("•") === 0) {
        if (!inList) {
          html.push('<ul class="ib-quiz-list">');
          inList = true;
        }
        // Keep the bullet character in the text so it always shows
        var itemText = line;
        html.push("<li>" + itemText + "</li>");
      } else {
        // Regular paragraph line
        closeList();
        html.push("<p>" + line + "</p>");
      }
    });

    closeList();

    // 🔒 Safety: if somehow nothing rendered, fall back to a single paragraph
    if (!html.length && trimmed) {
      return "<p>" + trimmed + "</p>";
    }

    return html.join("");
  }

    function buildSupportCta(productKey) {
    if (!productKey) return "";

    var href = productLinks[productKey];
    var label = productCtas[productKey];
    if (!href || !label) return "";

    // Optional product thumbnail for the CTA
    var imgSrc = productThumbs[productKey];
    var productName;

    if (productKey === "CompleteSystem") {
      productName = "Complete System";
    } else {
      productName = productKey;
    }

    var altText = productName
      ? productName + " bottle"
      : "Inner Botanica product";

    // Base CTA button with optional image
    var html =
      '<a class="ib-quiz-cta" href="' + href + '">' +
        '<span class="ib-quiz-cta__inner">' +
          (imgSrc
            ? '<span class="ib-quiz-cta__image">' +
                '<img src="' + imgSrc + '" alt="' + altText + '">' +
              "</span>"
            : ""
          ) +
          '<span class="ib-quiz-cta__label">' + label + "</span>" +
        "</span>" +
      "</a>";

    // Attach up to two testimonials under the CTA
    var tList = productTestimonials[productKey] || [];
    if (tList && tList.length) {
      html += '<div class="ib-quiz-testimonials">';

      tList.slice(0, 2).forEach(function(t) {
        var quote = t.quote || "";
        var name = t.name || "";
        var img = t.image || "";

        html += '<div class="ib-quiz-testimonial">';

        if (img) {
          html +=
            '<div class="ib-quiz-testimonial__avatar">' +
              '<img src="' + img + '" alt="' +
              (name ? "Photo of " + name : "Customer photo") +
              '">' +
            "</div>";
        }

        html += '<div class="ib-quiz-testimonial__content">';

        if (quote) {
          html +=
            '<p class="ib-quiz-testimonial__quote">“' +
            quote +
            '”</p>';
        }

        if (name) {
          html +=
            '<p class="ib-quiz-testimonial__name">— ' +
            name +
            "</p>";
        }

        html += "</div>"; // .ib-quiz-testimonial__content
        html += "</div>"; // .ib-quiz-testimonial
      });

      html += "</div>"; // .ib-quiz-testimonials
    }

    return html;
  }



    function buildEmailOptInGate() {
  return (
    '<div class="ib-quiz-email-optin ib-quiz-email-optin--gate">' +
      '<h3 class="ib-quiz-email-optin__title">' +
        "Unlock Your Full Results" +
      "</h3>" +
      '<p class="ib-quiz-email-optin__body">' +
        "Enter your email to discover:" +
      "</p>" +
      '<ul class="ib-quiz-email-optin__benefits">' +
        "<li>What this reveals about you</li>" +
        "<li>Your secondary pattern</li>" +
        "<li>Your 3-part sanctuary roadmap</li>" +
        "<li><strong>Bonus:</strong> 10% off your first order</li>" +
      "</ul>" +
      '<form class="ib-quiz-email-optin__form ib-quiz-email-form" data-location="gate" novalidate>' +
        '<input type="email" name="email" class="ib-quiz-email-optin__input" placeholder="Enter your email" required />' +
        '<button type="submit" class="ib-quiz-btn ib-quiz-btn--primary ib-quiz-email-optin__submit">' +
          "Unlock My Results" +
        "</button>" +
        '<p class="ib-quiz-email-optin__disclaimer">' +
          "We\u2019ll never sell or share your email." +
        "</p>" +
        '<p class="ib-quiz-email-message" aria-live="polite"></p>' +
      "</form>" +
      '<div class="ib-quiz-email-optin__confirmation" aria-live="polite"></div>' +
    "</div>"
  );
}



   
   function renderResults(primaryKey, secondaryKey) {
    if (!resultsContainer) return;

    var archetype = archetypes[primaryKey];
    if (!archetype) {
      resultsContainer.innerHTML = "<p>We could not read your pattern this time. Please try again.</p>";
      return;
    }

    var s = archetype.sections || {};
    var roadmap = s.roadmap || {};
    var support = s.supportPathway || {};

        // Derive human-readable names for primary/secondary
    var primaryName = archetype.name || primaryKey;
    var secondaryName =
      secondaryKey && archetypes[secondaryKey]
        ? archetypes[secondaryKey].name
        : null;

 // Resolve hero image for this primary archetype (optional)
    var heroSrc = heroImages[primaryKey] || "";

    var supportConfig = supportProducts[primaryKey] || {};

    var overlayBlock = "";
    if (secondaryKey) {
      var overlayKey = primaryKey + "_" + secondaryKey;
      var overlay = overlays[overlayKey];
          if (overlay) {
        overlayBlock =
          '<section class="ib-quiz-results__section">' +
          "<h2>" + overlay.title + "</h2>" +
          convertPseudoBullets(overlay.body || "") +
          "</section>";
      }

    }

 var roadmapHtml = "";
    (roadmap.steps || []).forEach(function(step) {
      roadmapHtml +=
        '<div class="ib-quiz-roadmap-step">' +
        "<h3>" + step.heading + "</h3>" +
        convertPseudoBullets(step.body || "") +
        "</div>";
    });

       // Primary support block + CTA
    var primarySupportHtml = "";
    var primaryProductKey = supportConfig.primary || supportConfig.completeSystem;
      if (support.primary) {
      var primaryCtaHtml = buildSupportCta(primaryProductKey);
      primarySupportHtml =
        '<div class="ib-quiz-support__block">' +
        "<h3>" + support.primary.label + "</h3>" +
        convertPseudoBullets(support.primary.body || "") +
        (primaryCtaHtml || "") +
        "</div>";
    }


    // Secondary support blocks + CTAs (one per item, in order)
    var secondarySupportHtml = "";
    var secondaryProducts = supportConfig.secondary || [];
      (support.secondary || []).forEach(function(item, index) {
      var secondaryProductKey = secondaryProducts[index];
      var secondaryCtaHtml = buildSupportCta(secondaryProductKey);
      secondarySupportHtml +=
        '<div class="ib-quiz-support__block">' +
        "<h3>" + item.label + "</h3>" +
        convertPseudoBullets(item.body || "") +
        (secondaryCtaHtml || "") +
        "</div>";
    });


    // Complete system block + CTA
    var completeSystemHtml = "";
    if (support.completeSystem) {
      var completeProductKey = supportConfig.completeSystem;
      var completeCtaHtml = buildSupportCta(completeProductKey);
      completeSystemHtml =
        '<div class="ib-quiz-support__block">' +
        "<h3>" + support.completeSystem.label + "</h3>" +
        convertPseudoBullets(support.completeSystem.body || "") +
        (completeCtaHtml || "") +
        "</div>";
    }


    // Main bottom CTA – point to the same product as the primary recommendation
    var mainProductKey = primaryProductKey;

        var html =
      '<div class="ib-quiz-results__header">' +
      '<p class="ib-quiz-results__eyebrow">Your Feminine Shift Archetype</p>' +
      '<h1 class="ib-quiz-results__title">' + archetype.name + "</h1>" +
      '<p class="ib-quiz-results__signature">' + archetype.signature + "</p>" +
      "</div>" +
       // Hero image between header and body (only if configured)
      (heroSrc
        ? '<div class="ib-quiz-results__hero">' +
            '<img src="' + heroSrc + '" alt="' + primaryName + ' archetype illustration">' +
          "</div>"
        : "") +

      // EMAIL GATE - appears after hero image
      buildEmailOptInGate() +

      // GATED CONTENT - blurred until email submitted
      '<div class="ib-quiz-results__gated" id="ib-quiz-gated-content">' +
      '<div class="ib-quiz-results__gated-mask"></div>' +
      '<div class="ib-quiz-results__gated-inner">' +

      '<div class="ib-quiz-results__body">' +
      '<section class="ib-quiz-results__section">' +
      "<h2>What This Reveals About You</h2>" +
      convertPseudoBullets(s.whatThisReveals || "") +
      "</section>" +

      overlayBlock +

      '<section class="ib-quiz-results__section">' +
      "<h2>Your Body's Understory</h2>" +
      convertPseudoBullets(s.bodyUnderstory || "") +
      "</section>" +

      '<section class="ib-quiz-results__section">' +
      "<h2>" + (roadmap.title || "Your 3-Part Sanctuary Roadmap") + "</h2>" +
      '<div class="ib-quiz-roadmap">' + roadmapHtml + "</div>" +
      "</section>" +

      '<section class="ib-quiz-results__section ib-quiz-results__section--support">' +
      "<h2>" + (support.title || "Your Inner Botanica Support Pathway") + "</h2>" +
      '<div class="ib-quiz-support">' +
      primarySupportHtml +
      secondarySupportHtml +
      completeSystemHtml +
      "</div>" +
      "</section>" +

      '<section class="ib-quiz-results__section ib-quiz-results__section--becoming">' +
      "<h2>Your Becoming</h2>" +
      convertPseudoBullets(s.becoming || "") +
      "</section>" +
      "</div>" +
      "</div>" + // end .ib-quiz-results__gated-inner
      "</div>" + // end .ib-quiz-results__gated

      '<div class="ib-quiz-results__cta">' +
      '<button class="ib-quiz-btn ib-quiz-btn--ghost" id="ib-quiz-retake">Start Over</button>' +
      "</div>";


    resultsContainer.innerHTML = html;

    // Save the rendered HTML + meta for email sending
    lastResult = {
      primaryKey: primaryKey,
      primaryName: primaryName,
      secondaryKey: secondaryKey || null,
      secondaryName: secondaryName,
      html: resultsContainer.innerHTML
    };

    var retakeBtn = document.getElementById("ib-quiz-retake");
    if (retakeBtn) {
      retakeBtn.addEventListener("click", function() {
        // Reset quiz state and go back to question 1
        currentIndex = 0;
        answers = [];
        // Hide results, show questions
        switchState("questions");
        renderQuestion();
        // Clear the hash to reset URL
        history.pushState("", document.title, window.location.pathname);
        // Scroll to top
        window.scrollTo({ top: 0, behavior: "smooth" });
      });
    }

    console.log("[IB Quiz] renderResults: binding email opt-ins now");
// NOW that the results (and email opt-in forms) exist in the DOM,
// bind the submit handlers
setupEmailOptIns();
  }

 // ------------------------------
// Email opt-in wiring (IB UI -> hidden Omnisend form)
// ------------------------------
function ibPopulateOmnisendQuizFields() {
  var container = document.getElementById("ib-quiz-omnisend-container");
  if (!container || !lastResult || !lastResult.primaryKey) {
    console.log("[IB Quiz] ibPopulateOmnisendQuizFields: missing container or lastResult");
    return;
  }

  var mappings = [
    { name: "quiz_archetype_key", value: lastResult.primaryKey },
    { name: "quiz_archetype_name", value: lastResult.primaryName },
    { name: "quiz_secondary_key", value: lastResult.secondaryKey },
    { name: "quiz_secondary_name", value: lastResult.secondaryName },
    { name: "quiz_source", value: "sanctuary_quiz" }
  ];

  mappings.forEach(function(map) {
    if (!map.value) return;

    // Try several selector patterns to match Omnisend’s naming convention
    var selector =
      'input[name="' + map.name + '"], ' +
      'input[name="' + map.name + 'Field"], ' +
      'input[name*="' + map.name + '"]';

    var inputs = container.querySelectorAll(selector);

    console.log("[IB Quiz] Mapping quiz field → Omnisend", {
      property: map.name,
      value: map.value,
      matchedInputs: inputs.length
    });

    inputs.forEach(function(input) {
      input.value = map.value;
    });
  });
}


function setupEmailOptIns() {
  if (!sectionEl) {
    console.warn("[IB Quiz] setupEmailOptIns: sectionEl not found");
    return;
  }

  var forms = sectionEl.querySelectorAll(".ib-quiz-email-form");
  console.log("[IB Quiz] setupEmailOptIns: found email forms:", forms.length);
  if (!forms.length) return;

  forms.forEach(function(form) {
    if (form.__ibEmailBound) return;
    form.__ibEmailBound = true;

    var emailInput = form.querySelector('input[type="email"]');
    var messageEl = form.querySelector(".ib-quiz-email-message");
    var submitBtn = form.querySelector('button[type="submit"]');

    console.log("[IB Quiz] Binding email opt-in form", {
      location: form.getAttribute("data-location"),
      hasEmail: !!emailInput,
      hasMessage: !!messageEl,
      hasSubmit: !!submitBtn
    });

    if (!emailInput || !messageEl || !submitBtn) return;

    form.addEventListener("submit", function(e) {
      e.preventDefault();
      console.log("[IB Quiz] Email form submitted:", form.getAttribute("data-location"));

      var email = (emailInput.value || "").trim();
      if (!email) {
        messageEl.textContent = "Please enter a valid email address.";
        console.warn("[IB Quiz] No email entered");
        return;
      }

      // Validate email format
      var emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(email)) {
        messageEl.textContent = "Please enter a valid email address.";
        console.warn("[IB Quiz] Invalid email format:", email);
        return;
      }

      console.log("[IB Quiz] Email entered:", email);

      if (!lastResult || !lastResult.primaryKey) {
        console.warn("[IB Quiz] Email opt-in submitted but lastResult is empty.", lastResult);
      }

      // 1. Funnelocity — captured immediately, no dependency on Omnisend
      document.dispatchEvent(new CustomEvent("funnelocity:opt-in", {
        detail: { email: email, provider: "omnisend", source: "quiz" }
      }));

      // Populate quiz-related hidden fields (best-effort, before Omnisend retry)
      ibPopulateOmnisendQuizFields();

      submitBtn.disabled = true;
      messageEl.textContent = "Sending your results...";

      // 2. Omnisend — retry until the embedded form initializes (up to 10s)
      (function submitToOmnisend(emailVal, attempt) {
        var container = document.getElementById('omnisend-embedded-v2-6937c53dbf0fd919156e1d1c');
        if (!container) {
          console.warn('[IB Quiz] Omnisend container not found');
          return;
        }
        var form = container.querySelector('form');
        if (form) {
          var input = form.querySelector('input[type="email"]');
          if (input) {
            var nativeSetter = Object.getOwnPropertyDescriptor(
              HTMLInputElement.prototype, 'value'
            ).set;
            nativeSetter.call(input, emailVal);
            input.dispatchEvent(new Event('input', { bubbles: true }));
            form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
            console.log('[IB Quiz] Omnisend form submitted via retry');
          }
        } else if (attempt < 20) {
          setTimeout(function() { submitToOmnisend(emailVal, attempt + 1); }, 500);
        } else {
          console.warn('[IB Quiz] Omnisend form never initialized after 10s');
        }
      })(email, 0);

      // SUCCESS UI: collapse *all* quiz opt-ins into a thank-you state
      // Capture scroll position before any DOM changes to prevent unwanted scrolling
      var scrollYBefore = window.scrollY;

var inlineMessage = "💛 Your results are on their way to your inbox. Keep scrolling for your full roadmap.";
var bottomMessage = "💛 Your results are on their way to your inbox.";

var optinWrappers = sectionEl.querySelectorAll(".ib-quiz-email-optin");

// UNLOCK GATED CONTENT
var gatedContent = document.getElementById("ib-quiz-gated-content");
if (gatedContent) {
  gatedContent.classList.add("is-unlocked");
}

optinWrappers.forEach(function(wrapper) {
  // prepare for fade
  wrapper.classList.add("ib-optin-fade-transition", "ib-optin-fade-out");

  // after fade-out completes (~250ms), flip content and fade back in
  setTimeout(function() {
    wrapper.classList.add("is-complete"); // hide form, show confirmation

    var confirmationEl = wrapper.querySelector(".ib-quiz-email-optin__confirmation");
    if (confirmationEl) {
      var wrapperForm = wrapper.querySelector(".ib-quiz-email-form");
      var location = wrapperForm ? wrapperForm.getAttribute("data-location") : null;

      if (location === "gate") {
        confirmationEl.innerHTML = "🔓 Your full results are now unlocked below!";
      } else if (location === "inline") {
        confirmationEl.textContent = inlineMessage;
      } else {
        confirmationEl.textContent = bottomMessage;
      }
    }

    // clear any old inline error/message
    var msg = wrapper.querySelector(".ib-quiz-email-message");
    if (msg) msg.textContent = "";

    // fade back in with new content
    wrapper.classList.remove("ib-optin-fade-out");
    wrapper.classList.add("ib-optin-fade-in");

    // Restore scroll position to keep user where they were
    window.scrollTo(0, scrollYBefore);

    // cleanup helper classes after the fade-in finishes
    setTimeout(function() {
      wrapper.classList.remove("ib-optin-fade-transition", "ib-optin-fade-in");
      // Final scroll position restore in case of any delayed reflows
      window.scrollTo(0, scrollYBefore);
    }, 260);
  }, 260);
});

// Reset just this form’s button state
submitBtn.disabled = false;

    });
  });
}


// When Omnisend signals forms are ready, populate quiz fields if we already have a result
window.addEventListener("omnisendForms", function() {
  ibPopulateOmnisendQuizFields();
});


  function sendQuizEvent(primary, secondary) {
    console.log("[IB Quiz] Completed", {
      primary_archetype: primary,
      secondary_archetype: secondary,
      scores: scores
    });

    // Report to Funnelocity
    if (DATA.reportQuizResults) {
      DATA.reportQuizResults({
        primaryArchetype: primary,
        secondaryArchetype: secondary,
        answers: answers,
        scores: scores
      });
    }
  }

  
    // ---- Dev / QA: direct archetype preview via URL params ----
  (function setupArchetypePreview() {
    if (!resultsContainer) return;

    // ?ib_primary=BSO&ib_secondary=VEA&optin=no (case-insensitive)
    var params = new URLSearchParams(window.location.search);
    var primary = params.get("ib_primary");
    if (!primary) return; // no param = normal quiz flow

    // Convert to uppercase to match archetype keys
    primary = primary.toUpperCase();
    var secondary = params.get("ib_secondary");
    if (secondary) {
      secondary = secondary.toUpperCase();
    }

    // Check if optin should be hidden
    var optinParam = params.get("optin");
    var hideOptin = optinParam && optinParam.toLowerCase() === "no";

    // Guard: only use valid keys
    if (!archetypes[primary]) {
      console.warn("[IB Quiz] Unknown ib_primary archetype:", primary);
      return;
    }
    if (secondary && !archetypes[secondary]) {
      console.warn("[IB Quiz] Unknown ib_secondary archetype:", secondary);
      secondary = null;
    }

    // Hide marketing sections if on marketing quiz page
    hideMarketingSections();

    // Jump straight to results view
    switchState("results");
    renderResults(primary, secondary || null);

    // Hide email opt-in sections if optin=no
    if (hideOptin) {
      var optinSections = document.querySelectorAll(".ib-quiz-email-optin");
      optinSections.forEach(function(section) {
        section.style.display = "none";
      });
      console.log("[IB Quiz] Email opt-in sections hidden via optin=no param");
    }
  })();



})();


